import Behaviour, { SingleBehaviour } from "../../../lib/ui/Behaviour";
import TheoryCraftingSidebar from "./TheoryCraftingSidebar";
import OverviewLayer from "./OverviewLayer";
import { MethodPackManager } from "../../MethodPackManager";
import MethodEditor from "./MethodEditor";
import { FakeLodash } from "../../../lib/coreutil/FakeLodash";
export default class TheoryCrafter extends Behaviour {
    constructor(app) {
        super();
        this.app = app;
        this.method_editor = this.withSub(new SingleBehaviour());
        MethodPackManager.instance().saved.on(async () => {
            await this.layer.filter_control.refreshFilterIndex();
        }).bindTo(this.lifetime_manager);
        this.method_editor.behaviour.subscribe((b, old_b) => {
            if (b && !old_b) {
                this.sidebar.setVisible(false);
                this.layer.remove();
            }
            else if (!b && old_b) {
                this.sidebar.setVisible(true);
                this.layer.addTo(this.app.map);
            }
        });
        this.method_editor.content_stopped.on(() => {
            this.method_editor.set(null);
        });
    }
    begin() {
        this.sidebar = new TheoryCraftingSidebar(this).prependTo(this.app.main_content);
        this.app.favourites.method_favourite_changed.on(change => {
            this.sidebar.notifyFavouriteChange(change);
        }).bindTo(this.lifetime_manager);
        this.app.map.invalidateSize();
        this.layer = new OverviewLayer(this).addTo(this.app.map);
    }
    end() {
        this.sidebar.remove();
        this.layer.remove();
    }
    async editMethod(method) {
        let copy = {
            clue: method.clue,
            pack: method.pack,
            method: FakeLodash.cloneDeep(method.method)
        };
        const really = await (async () => {
            let active_editor = this.method_editor.get();
            if (!active_editor)
                return true;
            return await active_editor.requestClosePermission();
        })();
        if (really) {
            this.method_editor.set(new MethodEditor(this, copy));
        }
    }
}
